module.exports = __webpack_public_path__ + "assets/media/evening.9b3938af.mp3";